
import axios from 'axios';
    

    
export const  axios_cabinetscompagnies_getdatasparametrage = async ()=>{
    return  await axios.get(`/cabinetscompagnies/datasparametrage`,{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}


export const  axios_cabinetscompagnies_update = async (infoscontacts)=>{
    return  await axios.post(`/cabinetscompagnies/updatecompagniecourtier`,{...infoscontacts},{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}
    
export const  axios_cabinetscompagnies_create= async (infoscontacts)=>{
    return  await axios.post(`/cabinetscompagnies/create`,{...infoscontacts},{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}
    

// A DEPLACER DANS COURTIER
export const  axios_cabinetscompagnies_updateauth= async ({courtier,autorisation,ROLE,type,compagnie_mini,gamme_mini,type_tarif})=>{
    return await axios.post(`/cabinetscompagnies/updateauthcompagnies_courtier`,{courtier,autorisation,ROLE,type,compagnie_mini,gamme_mini,type_tarif},{headers:{'Accept':'application/json'} }); 
}


export const  axios_cabinetscompagnies_registerappellation = async ({courtier,autorisation})=>{
    return   await axios.post(`/cabinetscompagnies/registerappellation`,{courtier,autorisation},{headers:{'Accept':'application/json'} }); 
}